import {useEffect, useRef, useState} from 'react';
import {Link} from "react-router-dom";
import {UseDelete, UseDownload, UsePost, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";
import CardMenu from "../../components/card-menu";
import Menu from "./TopMenu";
import Button from "../../components/button";
import {Col, Modal, Row} from "react-bootstrap";
import Uploader from "../../components/uploader";
import UploadImage from "../../resources/images/upload.svg";
import Importer from "../../components/importer";
import {CountdownCircleTimer} from "react-countdown-circle-timer";
import JobDone from "../../resources/images/done.svg";
import HTMLReactParser from "html-react-parser";
import {UseRequest} from "../../hooks/UseRequest";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import Text from "../../components/input/text";
import TabLabel from "../../components/tabLabel";
import {Plus, Upload} from "react-feather";
import UseGetFormData from "../../hooks/UseGetFormData";


const CountDown = (props) => {
    const {onStop, fetchData, afterFetch} = props

    const timers = [10, 0]
    const colors = ["#A30000", "#A30000"]


    const onUpdate = (counter) => {
        if (counter === 0) {
            fetchData().then(data => {
                if (typeof afterFetch === "function") {
                    afterFetch()
                }
            })
        }
    }


    const onComplete = () => {
        return {shouldRepeat: true, delay: 0}
    }

    return (<div className="CountDown">
            <span className="CountDownStop" data-tip="Stop process" onClick={onStop}>x</span>
            <CountdownCircleTimer size={30} duration={10} strokeWidth={4} isPlaying={true}
                colors={colors} colorsTime={timers} onUpdate={onUpdate} onComplete={onComplete}
            >
                {({remainingTime}) => remainingTime}
            </CountdownCircleTimer>
        </div>
    )
}


const Entities = ({robinson, audience}) => {
    const [isLoading, setIsLoading] = useState(true)
    const [columns, setColumns] = useState([])
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())
    const [showModal, setShowModal] = useState(false);

    const [uploadState, setUploadState] = useState()
    const [progress, setProgress] = useState(0)
    const [importResult, setImportResult] = useState()

    const formRef = useRef()
    const [errors, setErrors] = useState()
    const [fields, setFields] = useState([])
    const AudienceMenu = Menu({audience: audience})


    const [searchColumn, setSearchColumn] = useState('mobile_phone')
    const [searchColumns, setSearchColumns] = useState([])


    const fetchData = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        if(robinson){
            filters['robinson.status'] = true
        }

        const requestEntities = await UsePut(`/audiences/${audience?._id?.$oid}/entities/get`,
            {data: filters}
        );


        const columns = []
        const requestFields = await UsePut(
            `/audiences/${audience?._id?.$oid}/fields/get/audience`,
            {data: {offset: 0}}
        )


        if (requestFields?.entities?.length > 0) {
            const searchCols = []
            requestFields.entities.map((field) => {
                    if (field?.is_filter === 'on') {
                        searchCols.push({value: field.name, label: field.name.replace('_', ' ')})
                    }

                    columns.push(
                        field?.name !== 'first_name' ?
                            {label: field.name, prop: field.name} :
                            {
                                label: field.name, prop: field.name, output: (entity) => {
                                    return <Link to={`${entity?._id?.$oid}`}>
                                        <strong>{entity?.first_name}</strong>
                                    </Link>;
                                }
                            }
                    )
            })
            columns.push({
                label: "Created at", prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            })

            setSearchColumns(searchCols)
        }


        return {
            columns  : columns,
            total    : requestEntities.total,
            fields   : requestFields?.entities,
            process  : requestEntities?.process,
            entitites: requestEntities?.entities?.length > 0 ? requestEntities.entities : []
        }
    };


    useEffect(() => {
        setIsLoading(true)
        fetchData().then((response) => {
            setFields(response.fields)
            setColumns(response.columns)
            setEntities(response.entitites);
            setTotalEntities(response.total)
            setIsLoading(false);

            if (response.process) {
                let percentage = Math.ceil((response.process.steps.current * 100) / response.process.steps.total)

                setProgress(percentage)
                setImportResult(response.process)


                if (percentage === 100) {
                    setUploadState(undefined)
                    setShowModal(true)
                    setProgress(100)
                }
            }

            setIsLoading(false)
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange, robinson]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete(`/audiences/${audience?._id?.$oid}/entities/delete`,
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );
        }
    };



    const downloadAllEntities = () => {
        void UseDownload(`/audiences/${audience?._id?.$oid}/entities/download`, {data: []})
    }


    const downloadEntities = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {
            void UseDownload(`/audiences/${audience?._id?.$oid}/entities/download`, {data: selected})
        }
    }


    const addNewEntity = () => {
        setShowModal(true)
    }


    const StopProcess = async (id_processes) => {

        await UseDelete(`/processes/delete`,
            {
                data: {idx: id_processes, force: 1}, onSuccess: (response) => {
                    fetchData()
                }
            }
        );
    }


    const ListingOptions = {
        entities            : entities,
        isLoading           : isLoading,
        currentPage         : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities       : totalEntities,
        currentLimit        : currentLimit,
        currentOrder        : currentOrder,
        searchColumns       : searchColumns,
        template            : "table",
        searchColumn        : searchColumn,
        onSearch            : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onChooseSearchColumn: (field) => {
            setSearchColumn(field.value)
        },
        onCleanSearch       : () => {
            setSearchValue("");
        },
        onChangePage        : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit       : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder       : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction      : (action) => {
            setBulkAction(action);
        },
        onClickApply        : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns             : columns,
        filters             : [],
        actions             : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)},
            {value: "download", label: "Download", action: (selected) => downloadEntities(selected)},
            {value: "download_all", label: "Download all", action: (selected) => downloadAllEntities(selected)},
        ],
        rowActions          : [
            {
                path : `/audiences/${audience?._id?.$oid}/entities/:id`,
                label: "Edit Entity",
                icon : "edit"
            },
        ],
        progress            : progress,
        addons              : {
            afterCard: <CardMenu {...AudienceMenu}/>,
            top      : {
                left:
                    <div className="d-flex">
                        <div className="d-none">
                            {progress > 0 && progress < 100 && <CountDown
                                fetchData={fetchData}
                                onStop={ev => StopProcess([importResult?._id])}
                                afterFetch={ev => setLastChange(Date.now())}
                            />}
                        </div>
                        <div className="me-2">
                            <Button
                                size="sm"
                                icon="plus"
                                color="primary"
                                isReady={!isLoading}
                                onClick={addNewEntity}
                                style={{height: '32px'}}
                            />
                        </div>
                    </div>
            }
        }
    };


    const afterUpload = (response) => {
        setUploadState(response)
    }


    const startImport = () => {
        setShowModal(false)
        setProgress(6)
    }


    const downloadReport = (ev) => {
        let filename = Date.now()
        const request = UseRequest(`${process.env.REACT_APP_BASE_API}/processes/resource/report`, {
            request: {
                method: 'PUT', data: {id_process: importResult._id}
            }
        })


        request.then((response) => {
            if (response.headers.has('Content-Disposition')) {
                filename = response.headers
                    .get('Content-Disposition')
                    .split('filename=')[1].split(';')[0]
                    .replaceAll('"', '')
            }
        })

        request
            .then(response => response.blob())
            .then(blob => {

                const anchor = document.createElement('a');
                anchor.href = window.URL.createObjectURL(blob);

                anchor.download = filename;
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove();

                window.setTimeout(() => {
                    StopProcess([importResult?._id]).then((response) => {
                        setShowModal(false)
                        setImportResult(undefined)
                    })
                }, 2000)
            })
    }

    const closeAndFinish = (ev) => {
        StopProcess([importResult?._id]).then((response) => {
            setShowModal(false)
            setImportResult(undefined)
        })
    }


    const handleSubmit = async (ev) => {
        ev.preventDefault()
        const PostData = {}
        const FormData = UseGetFormData(formRef)

        fields && fields.map((field) => {
            PostData[field.name] = FormData.get(field.name)
        })

        const request = await UsePost(
            `/audiences/${audience?._id?.$oid}/entities/insert`,
            {data: PostData}
        )


        if (request?.code >= 200 && request?.code < 299) {
            setLastChange(Date.now())
            setShowModal(false)
        } else {
            setErrors(request?.errors)
        }

    }


    const handleModalClose = (ev) => {
        if (uploadState?.id_process) {
            StopProcess([uploadState?.id_process]).then((response) => {
                setShowModal(false)
                setImportResult(undefined)
                setUploadState(undefined);
            })
        } else {
            setShowModal(false);
        }
    }


    const importTab = <TabLabel slug="info" label="Import" icon={<Upload/>} errors={errors}/>
    const createTab = <TabLabel slug="preview" label="Create" icon={<Plus/>} errors={errors}/>

    return (
        <>
            <Modal size="lg" className="add-sidebar-padding" centered show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title as="h6">
                        {uploadState && "Match Fields"}
                        {progress === 100 && "Import Result"}
                        {!uploadState && progress !== 100 && "Add Entities"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs defaultActiveKey="0">
                        <TabPane forceRender={true} key={'info'} tabKey={'info'} tab={importTab}>
                            <div style={{maxWidth: "400px", margin: '0px auto'}}>
                                {!uploadState && !importResult && <Uploader
                                    name="blacklist"
                                    image={UploadImage}
                                    isReady={!isLoading}
                                    title="Add contacts to the Audience"
                                    subtitle="Choose a CSV file (max size 20MB) and press Start Upload"
                                    endpoint={`${process.env.REACT_APP_BASE_API}/audiences/${audience?._id?.$oid}/entities/upload`}
                                    onSuccess={afterUpload}
                                />}

                                {uploadState && <Importer
                                    uploadState={uploadState}
                                    origins={uploadState?.options?.Lists[0]}
                                    targets={uploadState?.options?.Lists[1]}
                                    endpoint={`/audiences/${audience?._id?.$oid}/entities/import`}
                                    onStart={startImport}
                                />}

                                {progress === 100 && importResult &&
                                    <div className="form-ui white text-center max-width-450">
                                        <img alt="upload" src={JobDone} width="240"/>
                                        <h5 className="mb-2">{importResult?.details?.title}</h5>
                                        {importResult?.details?.subtitle &&
                                            <p>{HTMLReactParser(importResult.details.subtitle)}</p>
                                        }

                                        <div className="d-block mt-4 mb-4">
                                            <Button size="sm" icon="download" isReady={true} onClick={downloadReport}
                                                color="primary" label="Download Report" className="me-2"
                                            />
                                            <Button size="sm" icon="close" isReady={true} onClick={closeAndFinish}
                                                color="secondary" label="Close & Finish"
                                            />
                                        </div>
                                    </div>}
                            </div>
                        </TabPane>
                        <TabPane forceRender={true} key={'limits'} tabKey={'limits'} tab={createTab}>
                            <form ref={formRef} onSubmit={handleSubmit} autoComplete="off" style={{padding: '0px 15px 0px 15px'}}>
                                <Row>
                                    {fields && fields.map((field, index) => {
                                        return <Col key={`entities_field_${index}`} sm={3}>
                                            <Text
                                                size="sm"
                                                name={field.name}
                                                isReady={!isLoading}
                                                required={field?.required === "on"}
                                                error={errors && errors[field.name]}
                                                label={field.name.replace('_', ' ')}
                                                className="capitalize-labels errors-100"
                                                placeholder={`Type ${field.name.replace('_', ' ')}...`}
                                            />
                                        </Col>
                                    })}
                                </Row>

                                <Button
                                    size="sm"
                                    icon="check"
                                    color="primary"
                                    label="Create"
                                    style={{marginTop: '20px'}}
                                    isReady={!isLoading}
                                />
                            </form>

                        </TabPane>
                    </Tabs>


                </Modal.Body>
            </Modal>
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default Entities;